// Überträgt die auf der Produktseite gewählten Zusatzleistungen in das Buchungsformular.
export const buildInitialAddons = (cart) => {
  const deliveryItem = cart.find((it) => it.deliveryAddon?.enabled);
  const anySetup = cart.some((it) => it.setupAddon?.enabled);
  const anyCleaning = cart.some((it) => it.cleaningAddon?.enabled);
  const allDeclinedCleaning = cart.length > 0 && cart.every((it) => it.cleaningAddon && !it.cleaningAddon.enabled);
  const sumDelivery = cart.reduce((s, it) => s + (it.deliveryAddon?.enabled ? Number(it.deliveryAddon.price || 0) : 0), 0);
  return {
    hasDelivery: !!deliveryItem,
    deliveryAddress: deliveryItem?.deliveryAddon
      ? {
          street: deliveryItem.deliveryAddon.street || '',
          zip: deliveryItem.deliveryAddon.zip || '',
          city: deliveryItem.deliveryAddon.city || '',
          km: deliveryItem.deliveryAddon.km || 0,
        }
      : null,
    deliveryPriceOverride: sumDelivery > 0 ? sumDelivery : null,
    hasSetup: anySetup,
    cleaningChoice: anyCleaning ? 'kidsevent' : (allDeclinedCleaning ? 'eigenreinigung' : null),
  };
};

export default buildInitialAddons;
